__turbopack_context__.v({
  "banner": "redeem-gift-voucher-module-scss-module__7GajMq__banner",
  "heroContainer": "redeem-gift-voucher-module-scss-module__7GajMq__heroContainer",
  "heroContent": "redeem-gift-voucher-module-scss-module__7GajMq__heroContent",
});
